// EXTERNAL DEPENDENCIES
import React from 'react'
import { useDispatch } from 'react-redux'

// COMPONENTS
import LocationNameSection from '@/common/components/ui/location-name-section'

// HELPERS
import { useBusinessProfileReduxState } from '../../hooks'
import {
  updateAreValuesEdited,
  updateEditedProfilePreferencesDataValues,
} from '@/redux/features'

// TYPES
import { PortableAddress } from '@/types'

/**
 * Displays the LocationNameSection with the values in state
 */
export function EditBusinessLocationNameSection() {
  const dispatch = useDispatch()

  const {
    uneditedFormattedData,
    editedProfileData: { values },
  } = useBusinessProfileReduxState()

  const locationDisplayPreference =
    values?.profilePreferences?.locationDisplayPreference ||
    uneditedFormattedData?.profilePreferences?.locationDisplayPreference

  return (
    <LocationNameSection
      businessAddress={
        uneditedFormattedData?.businessAddress as PortableAddress
      }
      selectedLocationDisplayPreference={locationDisplayPreference}
      updateSelectedLocationDisplayPreference={(
        updatedAddressPreference: string,
      ) => {
        dispatch(
          updateEditedProfilePreferencesDataValues({
            locationDisplayPreference: updatedAddressPreference,
          }),
        )
        dispatch(updateAreValuesEdited(true))
      }}
    />
  )
}
